import { HeatmapModel } from "../models/heatmap.model";

export const modifyDataForHeatmapSensor = (seriesData: any): HeatmapModel => {
  const stringToNumberMap: any = {};
  const newData = [];
  const tickPositions: string[] = [];
  const identicalStringsList: any = [];
  const locationList: any = [];

  let time = 0;
  let is24hrsCycleComplete = false;

  // Track seen asset codes to ensure uniqueness
  const seenAssets: Record<string, boolean> = {};

  for (const item of seriesData) {
    locationList.push(item[3]);
    const assetCode = item[4];

    if (!(assetCode in stringToNumberMap)) {
      const newNumber = Object.keys(stringToNumberMap).length + 1;
      stringToNumberMap[assetCode] = newNumber;
    }

    if (time <= 23 && !is24hrsCycleComplete) {
      tickPositions.push(item[1].toString());
    } else if (time >= 24) {
      is24hrsCycleComplete = true;
      time = 0;
    }

    const newEntry = [stringToNumberMap[assetCode], time, item[2]];
    newData.push(newEntry);

    time++;
  }

  // Build identicalStringsList using unique assetCodes only
  for (const item of seriesData) {
    const assetCode = item[4];
    const sensorDisplayName = item[0];
    if (!seenAssets[assetCode]) {
      seenAssets[assetCode] = true;
      identicalStringsList.push(sensorDisplayName);
    }
  }

  return { newData, identicalStringsList, tickPositions, locationList };
};

export const modifyDataForHeatmapLevel = (seriesData: any): HeatmapModel => {
  const stringToNumberMap: any = {};
  const newData = [];
  const tickPositions: string[] = [];
  const identicalStringsList: any = [];
  const locationList: any = [];
  let time = 0;
  let is24hrsCycleComplete = false;

  for (const item of seriesData) {
    // debugger;
    const stringKey = item[0];
    locationList.push(item[3]);

    if (!(stringKey in stringToNumberMap)) {
      const newNumber = Object.keys(stringToNumberMap).length + 1;
      stringToNumberMap[stringKey] = newNumber;
    }

    if (time <= 23 && !is24hrsCycleComplete) {
      tickPositions.push(item[1].toString());
    } else if (time >= 24) {
      is24hrsCycleComplete = true;
      time = 0;
    }

    const newEntry = [stringToNumberMap[stringKey], time, item[2]];
    newData.push(newEntry);

    time++;
  }

  const sortedKeys = Object.keys(stringToNumberMap).sort(
    (a, b) => stringToNumberMap[a] - stringToNumberMap[b]
  );
  identicalStringsList.push(...sortedKeys);

  return { newData, identicalStringsList, tickPositions, locationList };
};

export const modifyDataForHeatmapLocation = (seriesData: any): HeatmapModel => {
  const stringToNumberMap: any = {};
  const newData = [];
  const tickPositions: string[] = [];
  const identicalStringsList: any = [];
  const locationList: any = [];
  let time = 0;
  let is24hrsCycleComplete = false;

  for (const item of seriesData) {
    const stringKey = item[0];
    locationList.push(item[3]);

    if (!(stringKey in stringToNumberMap)) {
      const newNumber = Object.keys(stringToNumberMap).length + 1;
      stringToNumberMap[stringKey] = newNumber;
    }

    if (time <= 23 && !is24hrsCycleComplete) {
      tickPositions.push(item[1].toString());
    } else if (time >= 24) {
      is24hrsCycleComplete = true;
      time = 0;
    }

    const newEntry = [stringToNumberMap[stringKey], time, item[2]];
    newData.push(newEntry);

    time++;
  }

  const sortedKeys = Object.keys(stringToNumberMap).sort(
    (a, b) => stringToNumberMap[a] - stringToNumberMap[b]
  );
  identicalStringsList.push(...sortedKeys);

  return { newData, identicalStringsList, tickPositions, locationList };
};
